import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";

import { userSessionReducer } from "../components/login/userSession.redux";
// import { subscriptionFormReducer } from '../components/subscriptionForm/subscriptionForm.redux';
// import { spectreAppReducer } from '../components/spectreApp/spectreApp.redux';
// import { sideBarReducer } from '../components/sideBar/sideBar.redux';
import { settingsReducer } from "../components/settings/settings.redux";
import { specsheetReducer } from "../components/specsheet/specsheet.redux";
import { bowlersReducer } from "../components/bowlers/bowlers.redux";
import { arsenalReducer } from "../components/arsenal/arsenal.redux";
import { dashboardReducer } from "../components/dashboard/dashboard.redux";
// import { syncDeviceModalReducer } from '../components/syncDeviceModal/syncDeviceModal.redux';
import { apiReducer } from "../components/api/api.redux";
// import { importLoginFormReducer } from '../components/ImportPSM/ImportLoginForm.redux';
// import { importPSMReducer } from '../components/ImportPSM/ImportPSM.redux';
import { pluginReducer } from "../components/plugins/plugin.redux";
import { devicesReducer } from "../components/devices/devices.redux";

export const reducers = combineReducers({
  userSession: userSessionReducer,
  // subscriptionForm: subscriptionFormReducer,
  // spectreApp: spectreAppReducer,
  // sideBar: sideBarReducer,
  settings: settingsReducer,
  specsheet: specsheetReducer,
  form: formReducer,
  bowlers: bowlersReducer,
  balls: arsenalReducer,
  dashboard: dashboardReducer,
  // syncDeviceModal: syncDeviceModalReducer,
  api: apiReducer,
  plugin: pluginReducer,
  devices: devicesReducer,
  // importLoginForm: importLoginFormReducer,
  // importPSM: importPSMReducer,
});
